import React from 'react';
import { useProducts } from '../customHooks/useProducts';
import { ProductType } from '../@types/product';

export const useGetHasProduct = (productType: ProductType) => {
  const { products } = useProducts();

  const hasProduct = React.useMemo(() => {
    if (!products || !products?.length) return false;
    return products?.find((product) => product.productType === productType);
  }, [productType, products]);
  return !!hasProduct;
};

export const usePlusRentEntitlement = (): boolean => {
  return useGetHasProduct(ProductType.MieterPlus);
};

export const useLivingBundleEntitlement = (): boolean => {
  return useGetHasProduct(ProductType.WohnenPlus);
};

export const useGetHasProductV2 = (productType: ProductType) => {
  const { products, initializing } = useProducts();

  const hasProduct = React.useMemo(() => {
    if (!products || !products?.length) return false;
    return !!products?.find((product) => product.productType === productType);
  }, [productType, products]);
  return { hasProduct, isloading: initializing };
};
